import { uniq } from 'lodash';

export default ['propertyService', (propertyService) => {

    const invalidItemOrGuests = (item, guests, status = undefined) => {
        let error = itemError(item, status);

        if (!error) {
            error = guestInputError(guests, item);
        }

        if (error) {
            return error;
        }

        return false;
    };

    const itemError = (item, status) => {
        if (item.available === false) {
            return 'Sorry, this event is not currently available.';
        }

        if (!item.preferred_time && !item.suggested) {
            return 'Please select your arrival time.';
        }

        if (item.phone_only || status === 1) {
            return 'Please call us to book this event.';
        }
    };

    const optionError = (item) => {
        const error = 'Please choose included options for all events';

        if (!item.requiredOptions || item.requiredOptions === 0) {
            return false;
        }

        if (item.item_children.length < item.requiredOptions) {
            return error;
        }

        if (item.item_children.filter(child => {
            return child.item_type === 'App\\OptionGroupOption'
                || child.type_name === 'OptionGroupOption';
        }).length !== item.requiredOptions) {
            return error;
        }
    };

    const guestLoop = (guests, item) => {
        let errors = {
            errorFields: [],
            guestCounter: []
        };

        for (const guest of guests) {
            if ((!guest.integration_reference && !guest.title)
                || (!guest.integration_reference && !guest.first_name)
                || !guest.last_name
                || (propertyService.get('hasIntegration') && !guest.gender)) {
                errors.errorFields.push('required');
                continue;
            }

            if (item.gender && item.gender !== guest.gender) {
                errors.errorFields.push('gender');
                continue;
            }

            errors.guestCounter.push(guest.title + guest.first_name + guest.last_name);
        }

        return errors;
    };

    const guestInputError = (guests, item) => {
        const errors = guestLoop(guests, item);

        if (errors.errorFields.length) {
            return setGuestInputError(errors.errorFields, item);
        }

        if (uniq(errors.guestCounter).length !== guests.length
            && errors.guestCounter.length <= item.quantity
            && errors.guestCounter.length >= item.minimum_guests
        ) {
            return 'You\'ve entered the same guest details more than once.';
        }

        if (errors.guestCounter.length < item.minimum_guests) {
            return 'Too few guests added.';
        }

        if ((item.quantity + item.minimum_guests) < errors.guestCounter.length) {
            return `Not enough available quantity to add that many guests. You can add up to a total of ${item.quantity + item.minimum_guests} guests.`;
        }
    };

    const setGuestInputError = (errorFields, item) => {
        const genderErrors = errorFields.filter(error => error === 'gender');
        const requiredErrors = errorFields.filter(error => error === 'required');

        if (genderErrors.length === 1) {
            return `A guest has the wrong gender for this ${item.type || item.type_display}.`;
        }

        if (genderErrors.length > 1) {
            return `Several guests have the wrong gender for this ${item.type || item.type_display}.`;
        }

        if (requiredErrors.length === 1) {
            return 'A guest is missing required fields.';
        }

        if (requiredErrors.length > 1) {
            return 'Several guests are missing required fields.';
        }
    };

    const guestInputCustomiseError = (guests, item) => {
        let error = guestInputError(guests, item);

        if (error) {
            return error;
        }

        for (const guest of guests) {
            error = optionError(guest);
            if (error) {
                return error;
            }
        }
    };

    return {
        invalidItemOrGuests,
        itemError,
        guestInputCustomiseError,
        optionError
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/item/services/validate.service.js